<template>
  <div class="Sys-warp">
    <el-breadcrumb class="bread_crumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>房屋使用证明申请</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding-left: 85px;padding-right: 85px">
      <div class="title" id="title">房屋使用证明申请</div>
      <el-divider/>
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="110px" label-position="right"
               class="demo-ruleForm">

        <el-form-item label="申请主体" prop="applyName">
          <el-input v-model="formData.applyName" maxlength="100" class="input" placeholder="请输入申请主体名称"
                    :disabled="true"/>
        </el-form-item>

        <el-form-item label="租赁合同地址" prop="rentContractAddress">
          <el-input v-model="formData.rentContractAddress" maxlength="100" class="input" placeholder="请输入租赁合同地址"/>
          <div class="tips">
            提示：请填入租赁合同中的地址
          </div>
        </el-form-item>

        <el-form-item label="申请用途" prop="purpose">
          <el-radio-group v-model="formData.purpose">
            <el-radio v-for="(item,index) in purposeOptions" :label="item.key" v-if="item.key!=100">{{
                item.value
              }}
            </el-radio>
          </el-radio-group>
          <div class="tips">
            提示：请选择申请《房屋使用证明》的用途
          </div>
        </el-form-item>

        <el-form-item label="申请用途" prop="purposeDesc" v-if="formData.purpose ==2">
          <el-input v-model="formData.purposeDesc" maxlength="100" class="input" placeholder="请输入具体用途"/>
          <div class="tips">
            提示：请输入申请《房屋使用证明》的具体用途
          </div>
        </el-form-item>


        <el-form-item label="营业执照" prop="companyLicenseFiles">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.companyLicenseFiles.length }}/3
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.companyLicenseFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.companyLicenseFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.companyLicenseFiles.length<3"
                :action="'aa'"
                ref="companyFileUpload"
                :on-exceed="onExceed"
                :limit="3"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_COMPANY_LICENSE_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_COMPANY_LICENSE_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="法人证件照" prop="legalPersonFiles">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.legalPersonFiles.length }}/2
          </div>
          <div class="tips" style="margin-top: 0px;margin-bottom: 10px">
            提示：身份证正、反两面
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.legalPersonFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.legalPersonFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.legalPersonFiles.length<2"
                :action="'aa'"
                ref="legalPersonFileUpload"
                :on-exceed="onExceed"
                :limit="2"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_LEGAL_PERSON_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_LEGAL_PERSON_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="购买合同/租赁合同/转租合同" prop="rentContractFiles">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.rentContractFiles.length }}/20
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.rentContractFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.rentContractFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.rentContractFiles.length<20"
                :action="'aa'"
                ref="rentContractFileUpload"
                :on-exceed="onExceed"
                :limit="20"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_RENT_CONTRACT_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_RENT_CONTRACT_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>


        <el-form-item>
          <div style="display: flex">
            <el-button style="flex-grow: 3" type="primary" @click="submitForm('ruleForm')">提交</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>


    <!--    预览图片的dialog-->
    <el-dialog :visible.sync="previewImgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <!--    阅读告知书的dialog-->

    <!--提交成功的弹窗-->
    <el-dialog
        title="审批申请提交成功"
        width="500px"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="submitSuccessVisible">

      <div>
        <!--        <div style="display: flex"><span style="font-size: 16px">申请编号：{{-->
        <!--            successData.no-->
        <!--          }}{{ successData.applyNo }}</span>-->
        <!--          <div style="font-size: 20px">-->
        <!--            <i class="el-icon-document-copy" @click="copyApplyNo" style="margin-left: 20px;cursor: pointer;"></i>-->
        <!--          </div>-->
        <!--        </div>-->
        <div>
          可在网站或小程序中使用联系人手机号{{ this.formData.contactPhone }}查询审批进度
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                   <el-button type="primary" @click="jumpToHome">我知道了</el-button>
          </span>
    </el-dialog>

  </div>
</template>

<script>

import {
  getEnumByClassName,
  getProjectOptions, inApply,
  uploadFileToBaiduCloud,
  getInApplyNoticePicUrl, getApplyInfo,
  getEnterpriseInfo, companyLicenseApply, proofForUseApply
} from "@/api/api";
import util, {base64toFile} from "@/utils/util"
import constant from "@/utils/constant"
import sign from "@/component/sign"

var validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入电话号码'))
  } else if (!util.checkMobile(value)) {
    callback(new Error('请输入正确的11位手机号码'))
  } else {
    callback()
  }
}

export default {
  name: 'InApply',
  components: {
    sign
  },

  data() {
    return {
      timer: null,
      purposeOptions: [],
      businessType: constant.BUSINESS_TYPE_PROOF_OF_USE,
      enterpriseId: null, //变更审批进来的时候，如果企业存在，则有这个企业ID
      showSign: false,
      submitSuccessVisible: false,
      signNoticeVisible: false,
      agreeNotice: false,
      constant: constant,
      previewImgDialogVisible: false,
      readNoticeVisible: false,
      dialogImageUrl: null,
      applyId: null,
      projectOptions: [],
      inTypeOptions: [],
      industrialOptions: [],
      periodTypeOptions: [],
      noticePicUrl: '',
      confirmSignNoticeCountDown: 10,
      signFileName: null,
      successData: {
        no: '',
        applyNo: ''
      },
      formData: {
        applyName: '',
        isSelfEmployeed: null,
        prjBaseInfoId: null,
        inType: null,
        roomNumber: '',
        legalPerson: '',
        businessScope: '',
        registeredCapital: '',
        registeredAddress: '',
        squareMeasure: '',
        expectYearValue: '',
        expectYearTax: '',
        contact: '',
        contactPhone: '',
        industrials: [],
        periodTypes: [],
        companyLicenseFiles: [], //营业执照，核名通知书
        legalPersonFiles: [], //法人身份证照片
        rentContractFiles: [], //租赁合同照片
        shareholdersFiles: [], //股东证件
        otherFiles: [], //其他证明文件,
        purpose: null,
        purposeDesc: '',
        rentContractAddress: '',

      },
      rules: {
        prjBaseInfoId: [
          {required: true, message: '请选择入驻载体', trigger: 'change'},
        ],
        applyName: [
          {required: true, message: '请输入主体名称', trigger: 'change'},
        ],
        inType: [
          {required: true, message: '请选择入驻方式', trigger: 'change'},
        ],
        isSelfEmployeed: [
          {required: true, message: '请选择是否为个体户', trigger: 'change'},
        ],
        industrials: [
          {type: 'array', required: true, message: '请至少选择一个产业领域', trigger: 'change'}
        ],
        periodTypes: [
          {type: 'array', required: true, message: '请至少选择一个所属类型', trigger: 'change'}
        ],
        roomNumber: [
          {required: true, message: '请输入入驻场所门牌号', trigger: 'change'},
        ],
        legalPerson: [
          {required: true, message: '请输入法人代表名称', trigger: 'change'},
        ],
        businessScope: [
          {required: true, message: '请输入经营范围', trigger: 'change'},
        ],
        registeredCapital: [
          {required: true, message: '请输入注册资本', trigger: 'change'},
        ],
        registeredAddress: [
          {required: true, message: '请输入注册地址', trigger: 'change'},
        ],
        squareMeasure: [
          {required: true, message: '请输入载体面积', trigger: 'change'},
        ],
        expectYearValue: [
          {required: true, message: '请输入预计年产值', trigger: 'change'},
        ],
        expectYearTax: [
          {required: true, message: '请输入预计年税收', trigger: 'change'},
        ],
        contact: [
          {required: true, message: '请输入联系人名称', trigger: 'change'},
        ],
        contactPhone: [
          {required: true, validator: validPhone, trigger: 'change'},
        ],
        companyLicenseFiles: [
          {type: 'array', required: true, message: '请上传营业执照', trigger: 'change'},
        ],
        legalPersonFiles: [
          {type: 'array', required: true, message: '请上传法人证件照', trigger: 'change'},
        ],
        rentContractFiles: [
          {type: 'array', required: true, message: '请上传租赁合同照片', trigger: 'change'},
        ],
        shareholdersFiles: [
          {type: 'array', required: true, message: '请上传全部股东证件', trigger: 'change'},
        ],
        purpose: [
          {required: true, message: '请选择用途', trigger: 'change'},
        ],
        purposeDesc: [
          {required: true, message: '请输入具体用途', trigger: 'change'},
        ],
        rentContractAddress: [
          {required: true, message: '请输入合同地址', trigger: 'change'},
        ],
      }
    };
  },
  watch: {
    $route(to, from) {
      this.initData()
    }
  },
  created() {
    this.$nextTick(() => {
      this.initData();
    })
  },
  methods: {
    initData() {
      this.enterpriseId = this.$route.params.enterpriseId
      this.applyId = this.$route.params.applyId
      if (this.enterpriseId != null && this.enterpriseId == 0) {
        this.enterpriseId = null;
      }
      if (this.applyId != null && this.applyId == 0) {
        this.applyId = null;
      }
      if (this.enterpriseId == null && this.applyId == null) {
        this.jumpToHome()
      }
      console.log("enterpriseId=" + this.enterpriseId + ",applyId=" + this.applyId)
      this.resetForm('ruleForm')
      getEnumByClassName('EnumProofForUsePurpose').then(res => {
        this.purposeOptions = res.list
      })
      if (this.applyId != null) {
        this.getApplyInfo();
      } else {
        this.getEnterpriseInfo()
      }
    },
    getApplyInfo() {
      getApplyInfo(this.applyId).then(res => {
        if (res.code == 0) {
          let data = res.data.prjInApply;
          this.handleServerData(data)
        } else {
          this.jumpToHome()
        }
      })
    },
    getEnterpriseInfo() {
      getEnterpriseInfo(this.enterpriseId).then(res => {
        if (res.code == 0) {
          let data = res.data;
          data.applyName = data.name;
          this.handleServerData(data)
        } else {
          this.jumpToHome()
        }
      })
    },
    handleServerData(data) {
      this.formData.applyName = data.applyName
      this.formData.prjBaseInfoId = data.prjBaseInfoId
      this.formData.inType = data.inType
      this.formData.legalPerson = data.legalPerson
      this.formData.roomNumber = data.roomNumber
      this.formData.businessScope = data.businessScope
      this.formData.registeredCapital = data.registeredCapital
      this.formData.registeredAddress = data.registeredAddress
      this.formData.squareMeasure = data.squareMeasure
      this.formData.expectYearValue = data.expectYearValue
      this.formData.expectYearTax = data.expectYearTax
      this.formData.contact = data.contact
      this.formData.contactPhone = data.contactPhone
      this.formData.purpose = data.purpose
      this.formData.purposeDesc = data.purposeDesc
      this.formData.rentContractAddress = data.rentContractAddress

      for (var i = 0; i < data.attachmentList.length; i++) {
        let attachment = data.attachmentList[i]
        let value = {
          "name": attachment.ossFileName,
          "url": attachment.url
        }
        if (attachment.type == constant.CONST_COMPANY_LICENSE_FILE_TYPE) {
          this.formData.companyLicenseFiles.push(value);
        } else if (attachment.type == constant.CONST_LEGAL_PERSON_FILE_TYPE) {
          this.formData.legalPersonFiles.push(value);
        } else if (attachment.type == constant.CONST_RENT_CONTRACT_FILE_TYPE) {
          this.formData.rentContractFiles.push(value);
        } else if (attachment.type == constant.CONST_SHARE_HOLDERS_FILE_TYPE) {
          this.formData.shareholdersFiles.push(value);
        } else if (attachment.type == constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE) {
          this.formData.otherFiles.push(value);
        }
      }
    },
    beforeUpload(file, type) {
      let extension = util.getFileExtName(file.name)
      if (extension !== 'jpg' && extension != 'jpeg' && extension != 'png') {
        this.$message.error('请上传png、jpg、jpeg格式图片')
        return false
      }
      this.uploadFile(file, type)
      return false
    },
    uploadFile(file, type) {
      console.log("uploadFile.type=" + type)
      console.log(file)
      let fileList = this.getFileListByType(type);
      let _this = this;
      uploadFileToBaiduCloud(file, function (success) {
        console.log("upload success =" + JSON.stringify(success))
        fileList.push(success)
      }, function (fail) {
        _this.$message.error('上传失败')
      })
    },
    getFileListByType(type) {
      let fileList;
      if (type == constant.CONST_COMPANY_LICENSE_FILE_TYPE) {
        fileList = this.formData.companyLicenseFiles;
      } else if (type == constant.CONST_LEGAL_PERSON_FILE_TYPE) {
        fileList = this.formData.legalPersonFiles;
      } else if (type == constant.CONST_RENT_CONTRACT_FILE_TYPE) {
        fileList = this.formData.rentContractFiles;
      } else if (type == constant.CONST_SHARE_HOLDERS_FILE_TYPE) {
        fileList = this.formData.shareholdersFiles;
      } else if (type == constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE) {
        fileList = this.formData.otherFiles;
      }
      return fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.previewImgDialogVisible = true;
    },
    handleRemove(file, type) {
      // console.log('handleRemove.type=' + type)
      // console.log('file=' + JSON.stringify(file))
      // file = file.response
      // let fileList = this.getFileListByType(type);
      // for (let i = fileList.length - 1; i >= 0; i--) {
      //   if (file.url == fileList[i].url) {
      //     fileList.splice(i, 1)
      //   }
      // }
      // console.log("fileList=" + JSON.stringify(fileList))
    },
    onExceed() {
      this.$message.error("已超过最大文件数")
    },
    getFiles(refs) {
      let fileList = []
      if (this.$refs[refs] != undefined) {
        fileList = this.$refs[refs].uploadFiles
      }
      console.log(refs + ".fileList=" + JSON.stringify(fileList));
      let resultList = [];
      for (let i = 0; i < fileList.length; i++) {
        let file = fileList[i];
        if (file.status === 'success') {
        }
        let resultFile = file.response
        resultList.push(resultFile)
      }
      return resultList
    },
    submitForm(formName) {


      // this.formData.companyLicenseFiles = this.getFiles('companyFileUpload')
      // this.formData.legalPersonFiles = this.getFiles('legalPersonFileUpload')
      // this.formData.rentContractFiles = this.getFiles('rentContractFileUpload')
      // this.formData.shareholdersFiles = this.getFiles('shareHoldersFileUpload')

      console.log("营业执照=" + JSON.stringify(this.formData.companyLicenseFiles))
      console.log("法人证件=" + JSON.stringify(this.formData.legalPersonFiles))
      console.log("租赁合同=" + JSON.stringify(this.formData.rentContractFiles))
      console.log("股东证件=" + JSON.stringify(this.formData.shareholdersFiles))
      console.log("其他证明文件=" + JSON.stringify(this.formData.otherFiles))
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitToServer()
        } else {
          return false;
        }
      });
    },
    //取消阅读入驻告知书，跳转回首页
    submitToServer() {
      //封装附件
      let fileList = [];
      //营业执照，核名通知书
      for (var i = 0; i < this.formData.companyLicenseFiles.length; i++) {
        let item = this.formData.companyLicenseFiles[i];
        let file = {
          type: constant.CONST_COMPANY_LICENSE_FILE_TYPE,
          url: item.name
        }
        fileList.push(file);
      }
      //法人证件照片
      for (var i = 0; i < this.formData.legalPersonFiles.length; i++) {
        let item = this.formData.legalPersonFiles[i];
        let file = {
          type: constant.CONST_LEGAL_PERSON_FILE_TYPE,
          url: item.name
        }
        fileList.push(file);
      }
      //租赁合同照片
      for (var i = 0; i < this.formData.rentContractFiles.length; i++) {
        let item = this.formData.rentContractFiles[i];
        let file = {
          type: constant.CONST_RENT_CONTRACT_FILE_TYPE,
          url: item.name
        }
        fileList.push(file);
      }

      // //其他证明文件
      // for (var i = 0; i < this.formData.otherFiles.length; i++) {
      //   let item = this.formData.otherFiles[i];
      //   let file = {
      //     type: constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE,
      //     url: item.name
      //   }
      //   fileList.push(file);
      // }
      console.log("附件：" + JSON.stringify(fileList))
      const loading = this.$loading({
        lock: true,
        text: '请稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let _this = this
      proofForUseApply(fileList, this.businessType, this.enterpriseId, this.formData.rentContractAddress, this
          .formData.purpose, this.formData.purposeDesc).then(res => {
        loading.close()
        if (res.code == 0) {
          //成功
          _this.successData = res.data
          _this.submitSuccessVisible = true
        } else {
          //失败
          _this.$alert(res.msg, '失败', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // if (this.$refs['companyFileUpload'] != undefined) {
      //   this.$refs['companyFileUpload'].clearFiles();
      // }
      // this.$refs['legalPersonFileUpload'].clearFiles();
      // this.$refs['rentContractFileUpload'].clearFiles();
      //
      // if (this.$refs['shareHoldersFileUpload'] != undefined) {
      //   this.$refs['shareHoldersFileUpload'].clearFiles();
      // }
      if (this.$refs['sign'] != undefined) {
        this.$refs['sign'].overwrite();
      }
    },
    copyApplyNo() {
      let _this = this
      let str = this.successData.no.toString() + this.successData.applyNo.toString()
      this.$copyText(str).then(function (e) {
        console.log('复制成功', e.text)
        _this.$message.success("复制成功")
      }, function (e) {
        console.log(e)
        console.log('不能复制，复制失败')
        _this.$message.error("复制失败，请手动复制")
      })
    },
    jumpToHome() {
      this.$router.replace({
        name: 'home'
      });
    },
    // 当是否同意checkbox被勾选或取消时
  }
  ,
}
</script>
<style scoped>
.img {
  width: 147px;
  height: 147px;
  margin-right: 20px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.upload {
  display: inline-flex;
}

.input {
  width: 100%
}
</style>
